export default class DiscountRate {
  constructor(idInDb, value, date, underlyingAssetTypeId, currencyCode, rentalAmountFrom, rentalAmountTo, monthsCountFrom, monthsCountTo) {
    this.idInDb = idInDb;
    this.value = value;
    this.date = date;
    this.underlyingAssetTypeId = underlyingAssetTypeId;
    this.currencyCode = currencyCode;
    this.rentalAmountFrom = rentalAmountFrom;
    this.rentalAmountTo = rentalAmountTo;
    this.monthsCountFrom = monthsCountFrom;
    this.monthsCountTo = monthsCountTo;
  }

  static createNew() {
    return new DiscountRate(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
  }
}
